import { useCallback, useMemo } from 'react';
import type { ProjectType } from '@atlassian/jira-common-constants/src/index.tsx';
import { CoordinationClient } from '@atlassian/jira-engagement/src/ui/coordination-client/index.tsx';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useDeferEpMessageKey } from '../ep-messages/index.tsx';

export const useCoordinationClient = (projectType?: ProjectType) => {
	const epMessageId = useDeferEpMessageKey(projectType);

	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();

	const coordinationClient = useMemo(
		() => new CoordinationClient(cloudId, '/gateway/api', false, orgId, 'engagement'),
		[cloudId, orgId],
	);

	const start = useCallback(async () => {
		if (!epMessageId) return false;

		return coordinationClient.start(epMessageId);
	}, [epMessageId, coordinationClient]);

	const stop = useCallback(() => {
		if (!epMessageId) return false;

		return coordinationClient.stop(epMessageId);
	}, [epMessageId, coordinationClient]);

	return {
		start,
		stop,
	};
};
